module.exports = __webpack_public_path__ + "static/media/astronauts.f1f66712.png";